import React, { Component } from 'react'

export class SMMsvg extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
                width={20}
                height={20}
                viewBox="0 0 256 241"
                fill='#fff'
            >
                <path d="M254 188V2H2v186h111v29H75v22h106v-22h-38v-29h111zM19 19h217v151H19V19zm147.145 102.23c.044.088.22.132.353.22h-.088c-.089-.044-.221-.132-.265-.22zm7.977-45.705V48.42c-.22-2.6-2.38-4.672-5.068-4.672-1.851 0-3.482 1.058-4.363 2.512-11.635 9.432-26.268 21.552-48.172 21.552H90.691c-.309 0-.661 0-.97.088h-.132c-8.462-.044-15.294 6.787-15.294 15.249s6.831 15.294 15.294 15.294h.132c.309 0 .661.088.97.088h3.217l7.36 48.217 21.905-2.821-1.102-8.903 4.451-.661-1.278-8.462-4.319.661-4.672-28.119c2.16 0 4.099.088 5.333.22 20.186 1.719 33.32 13.266 44.03 22.037.132.132.353.309.529.441.132.088.309.132.353.22a4.975 4.975 0 0 0 2.512.661c2.512 0 4.672-1.851 4.98-4.319h.088V90.775a7.6 7.6 0 0 0 7.625-7.625c.088-4.231-3.35-7.625-7.581-7.625zm-7.713 36.141c-15.602-11.944-27.017-18.687-42.223-20.406V75.085c15.205-1.719 26.665-8.55 42.223-20.582v57.163z" />
            </svg>
        )
    }
}

export default SMMsvg